export default __webpack_public_path__ + "cd9cba7ba1ae63b854e694098cd585a5.svg";